/**
 * Extracts a human-readable message from an API error.
 *
 * Axios wraps HTTP errors such that the response body lives at
 * `err.response.data`. The highlights API returns validation failures as:
 *   { errors: { field: ["message", ...], ... } }
 *
 * When that shape is present, every field + message pair is joined into a
 * single string.  Otherwise the function falls back to `err.message`.
 *
 * @param {unknown} err
 * @returns {string}
 */
export const extractApiErrorMessage = (err) => {
  const errors = err?.response?.data?.errors
  if (errors && typeof errors === 'object') {
    const messages = Object.entries(errors)
      .flatMap(([field, msgs]) =>
        Array.isArray(msgs)
          ? msgs.map((msg) => `${field}: ${msg}`)
          : [`${field}: ${msgs}`],
      )
      .join(' ')
    if (messages) return messages
  }
  return typeof err === 'string' ? err : err?.message || 'Unknown error'
}
